import { FunctionComponent, PropsWithChildren } from 'react';

interface RegistrationWizardPageTitleProps extends PropsWithChildren {}

const RegistrationWizardPageTitle: FunctionComponent<RegistrationWizardPageTitleProps> = ({ children }) => {
  return <div className="text-4xl font-bold tracking-tighter text-primary-950 ">{children}</div>;
};

export default RegistrationWizardPageTitle;
